import { Addon } from '@domain/addon';
import { useGenericQuery } from '@hooks/use-generic-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

const getOfferAddons = async (offerId: string | undefined): Promise<Addon[]> => {
  const url = `${import.meta.env.VITE_OFFERS_HOST}/v1/nightgraph/offers/${offerId}/add-ons`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetOfferAddon = ({ offerId, enabled = true }: { offerId?: string | undefined; enabled?: boolean }) => {
  return useGenericQuery<Addon[] | null, RequestError>(
    ['get-offer-addons', offerId],
    () => (offerId ? getOfferAddons(offerId) : null),
    {
      enabled,
    }
  );
};
